var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { observer } from 'mobx-react';
var CellRenderer = function (_a) {
    var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex, columnCount = _a.columnCount, singleColumnRowIndices = _a.singleColumnRowIndices, ItemRendererComponent = _a.ItemRendererComponent, style = _a.style;
    // skip all other columns in a single column row
    var isSingleColumnRow = singleColumnRowIndices.includes(rowIndex);
    if (columnIndex > 0 && isSingleColumnRow) {
        return null;
    }
    if (!style) {
        style = {};
    }
    var itemStyle = isSingleColumnRow ? __assign(__assign({}, style), { width: '100%' }) : style;
    return (React.createElement("div", { style: __assign(__assign({}, itemStyle), { overflow: 'hidden', paddingLeft: columnIndex % columnCount === 0 ? 0 : 8 }) }, (React.createElement(ItemRendererComponent, { columnIndex: columnIndex, rowIndex: rowIndex }))));
};
export default observer(CellRenderer);
//# sourceMappingURL=CellRenderer.js.map